import script from "./Containers.vue?vue&type=script&setup=true&lang=js"
export * from "./Containers.vue?vue&type=script&setup=true&lang=js"

import "./Containers.vue?vue&type=style&index=0&id=222f33ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-222f33ac"]])

export default __exports__